import { $api } from './interceptor';
import { ICardFees } from '../types/cardFees';

const cardFeesApi = () => {
  const getCardFees = async () => {
    const { data } = await $api.get<ICardFees>('/api/card-fees');
    return data;
  };

  const updateCardFees = async (patch: Partial<ICardFees>) => {
    const { data } = await $api.put<ICardFees>('/api/card-fees', patch);
    return data;
  };

  return {
    getCardFees,
    updateCardFees,
  };
};

export const cardFeesService = cardFeesApi();
